import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import React, { useState } from 'react'

import { useAnalytics } from '../../lib/analytics'
import { Actions, Categories } from '../../lib/analytics/events'
import { MenuItem as SubMenuItemProps } from '../../operations.wp/types'
import MenuItem from './MenuItem'

const SubMenu = ({ item }: { item: SubMenuItemProps }) => {
  const useStyles = makeStyles(theme => ({
    listItem: {
      color: theme.palette.secondary.main,
      [theme.breakpoints.up('xs')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.2rem',
      },
    },
    listItemGutters: {
      padding: '0',
    },
    listItemRoot: {
      '&:hover, &:focus': {
        paddingLeft: '1.3rem',
      },
      display: 'inline-block',
      padding: '.5rem 1rem',
      textDecoration: 'none',
      transition: 'all .5s ease',
      width: '100%',
    },
    listRoot: {
      color: theme.palette.secondary.main,
      padding: '0',
      width: '100%',
    },
    subMenuListRoot: {
      paddingLeft: '1.5rem',
    },
    subMenuitems: {
      [theme.breakpoints.up('xs')]: {
        fontSize: '1.2rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1rem',
      },
      margin: 0,
    },
  }))

  const classes = useStyles()
  const { childItems, label } = item
  const [open, setOpen] = useState(false)
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      action: Actions.MenuItemClick,
      category: Categories.HeaderMenu,
      label,
      location: Categories.HeaderMenu,
    })
    setOpen(!open)
  }
  if (!childItems?.nodes?.length) return null

  return (
    <List
      aria-labelledby="nested-list-subheader"
      classes={{ root: classes.listRoot }}
      component="nav"
    >
      <ListItem button classes={{ gutters: classes.listItemGutters }} onClick={handleClick}>
        <ListItemText
          classes={{ primary: classes.listItem, root: classes.listItemRoot }}
          primary={label}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse unmountOnExit in={open} timeout="auto">
        <List disablePadding classes={{ root: classes.subMenuListRoot }} component="div">
          {childItems.nodes.map(node => {
            if (!node) return null
            return <MenuItem key={node.id} item={node} />
          })}
        </List>
      </Collapse>
    </List>
  )
}

export default SubMenu
